import type { CountryFeature, CountryProperties } from "../types";

export function getName(props: CountryProperties): string {
  return (
    props.ADMIN ||
    props.NAME_LONG ||
    props.NAME ||
    props.admin ||
    props.name ||
    "Unknown"
  );
}

export function getCode(props: CountryProperties): string {
  return props.ISO_A3 || props.iso_a3 || props.ISO_A2 || props.iso_a2 || "—";
}

export function getContinent(props: CountryProperties): string {
  return props.CONTINENT || props.continent || props.REGION_UN || "—";
}

export function getPopulation(props: CountryProperties): number | null {
  const p = props.POP_EST ?? props.pop_est;
  return typeof p === "number" ? p : null;
}

export function formatNumber(n: number): string {
  if (n >= 1e9) return (n / 1e9).toFixed(2) + "B";
  if (n >= 1e6) return (n / 1e6).toFixed(2) + "M";
  if (n >= 1e3) return (n / 1e3).toFixed(1) + "K";
  return n.toString();
}

// Compare features by object reference, not ISO code. Natural Earth has
// many features sharing ISO_A3 = "-99" (disputed/unrecognised territories),
// which caused every "-99" country to light up when hovering just one.
// Each feature is a unique object, so reference equality is accurate.
export function sameCountry(
  a: CountryFeature | null,
  b: CountryFeature | null
): boolean {
  return a === b;
}
